import React, { useState } from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "assets/svgIcons/AccordionExpandMoreIcon";
import { useDispatch, useSelector } from "react-redux";
import { AccordionStyled, PopUpContainer } from "assets/css/globle";
import {
  COMMON_SERVICES,
  headersConfigData
} from "redux/reduxToolkitServices/_commonServices/commonServices";
import {
  SITE_SERVICES
} from "redux/reduxToolkitServices/_commonServices/siteServices";
import {
  ADMIN_SITE_CONFIG,
  SITEID_GLOBAL_STATE,
  UPDATED_CAR_DATA_STATE,
} from "globalStore/globalStore";
import { useHookstate } from "@hookstate/core";
import {
  Heading,
  SiteDataRow,
  SiteDataWorkSection,
} from "pages/Admin/SiteSettings/SettingStyled";
import { UploadBtnWrapper } from "assets/css/globle";

import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import { useTranslation } from "react-i18next";
import XMLParser from "react-xml-parser";
import { useEffect } from "react";
import {
  createHoleMapImageDataStateAction,
  processGreenViewDataStateAction,
  uploadKmlDataStatusAction
} from "redux/reduxToolkitServices/_commonReducers/commonReducers";
import { API_STATUSES } from "redux/_helpers/statuses";
import Tooltip from "@mui/material/Tooltip";
import _ from "lodash";
import { convIntToRGB, featureKey, holeAreaType, deviceType } from "constant";
import moment from "moment";
import { getSiteSetupApiCall } from "redux/reduxToolkitServices/_commonApiCalls/api";
import VerifyPopup from "commonComponents/SideNav/sideNavSubWindows/VerifyPopup";
import { Loader } from "commonComponents/Loader/Loader";
import Button from "@mui/material/Button";
import FormControl from "@mui/material/FormControl";
import Select from 'react-select';

function getDateUTC(dTime) {
  if (!dTime) return null;
  var UTC_FORMAT = "DD-MMM-YYYY HH:mm UTC";
  if (moment.isMoment(dTime)) {
    // if moment, usually right after "send data to cars" button press
    var cloned = dTime.clone();
    return cloned.format(UTC_FORMAT);
  } else {
    if (dTime.includes("Z")) {
      // Check if incoming time to format is in UTC, usually just after publish all after midnight button pressed
      return moment.utc(dTime).format(UTC_FORMAT);
    } else {
      // usual condition is when date coming from db
      return moment(dTime).format(UTC_FORMAT);
    }
  }
}

const SiteDataConfiguration = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const { siteId } = useHookstate(SITEID_GLOBAL_STATE);
  const { isHoleDataModified, isTSModified } = useHookstate(ADMIN_SITE_CONFIG);
  const {
    siteSetupData,
    siteSetupStatus,
    siteSettingsData,
    kmlLayerData,
    uploadKmlDataStatus,
    createHoleMapImageDataState,
    createHoleMapImageDataStatus,
    processGreenViewDataState,
    processGreenViewDataStatus,
    verifySiteSetupDataState,
    resetSiteExtentsAndCtrPtToZeroStatusAction,
    ScheduleSiteDataPublishAction,
    ScheduleSiteDataPublishStatusAction,
    siteLocationsData
  } = useSelector((state) => state.commonReducers) || "";

  const {
    getV4GraphicsSiteData
  } = useSelector((state) => state.siteReducers) || "";

  const { updatedCarData } = useHookstate(UPDATED_CAR_DATA_STATE);

  const [openCommonModal, setOpenCommonModal] = useState(false);
  const [enableAZModal, setEnableAZModal] = useState(false);
  const [openKml, setOpenKml] = useState(false);
  const [modalText, setModalText] = useState("");
  const [modalName, setModalName] = useState("");
  const [kmlFileName, setKmlFileName] = useState("");
  const [pngReferenced, setPngReferenced] = useState(false);
  const [filesSelected, setFilesSelected] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [pngFileName, setPngFileName] = useState("");
  const [readyToUpload, setReadyToUpload] = useState(false);
  const [errorModal, setErrorModal] = useState(false);
  const [errorModalText, setErrorModalText] = useState("");
  const [errorModalStatus, setErrorModalStatus] = useState(false);
  const [processMapModal, setProcessMapModal] = useState(false);
  const [processGreenViewModal, setProcessGreenViewModal] = useState(false);
  const [resetCenterModal, setResetCenterModal] = useState(false);
  const [publishDataModal, setPublishDataModal] = useState(false);
  const [missingData] = useState([]);
  const [siteDataExists, setSiteDataExists] = useState(false);
  const [greenViewDataExists, setGreenViewDataExists] = useState(false);
  const [holeDataExists, setHoleDataExists] = useState(false);
  const [vduViewDataExists, setVduViewDataExists] = useState(false);
  const [teeMarkerSettingsExist, setTeeMarkerSettingsExist] = useState(false);
  const [teeMarkersExist, setTeeMarkersExist] = useState(false);
  const [poiDataExists, setPoiDataExists] = useState(false);
  const [siteDataSendDate, setSiteDataSendDate] = useState(null);
  const [mapSendDate, setMapSendDate] = useState(null);
  const [poiSendDate, setPoiSendDate] = useState(null);
  const [teeMarkerSendDate, setTeeMarkerSendDate] = useState(null);
  const [mapImageLastUpdate, setMapImageLastUpdate] = useState(null);
  const [greenViewSendDate, setGreenViewSendDate] = useState(null);
  const [featuresResortEdition, setFeaturesResortEdition] = useState(false);
  const [isEntireFleetG2, setIsEntireFleetG2] = useState(false);
  const [isEntireFleetLT, setIsEntireFleetLT] = useState(false);
  const [isEntireFleetFT, setIsEntireFleetFT] = useState(false);
  const [isEntireFleetWT, setIsEntireFleetWT] = useState(false);
  const [pendingPublishDate, setPendingPublishDate] = useState(null);
  const [carData, setCarData] = useState([]);
  const [verifyPopupOpen, SetVerifyPopupOpen] = useState(false);
  const [verifyText, setVerifyText] = useState("");
  const [verifyTitle, setVerifyTitle] = useState("");
  const [verifyLoding, setVerifyLoding] = useState(false);
  const [successKmlModal, setSuccessKmlModal] = useState(false);
  const [v3GraphicsSite, setV3GraphicsSite] = useState(0);
  const [v4GraphicsSite, setV4GraphicsSite] = useState("");

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    maxWidth: "400px",
    width: "100%",
    bgcolor: "background.paper",
    borderRadius: "5px",
    overflow: "hidden",
  };

  const missingDataPopup = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    maxWidth: "600px",
    width: "100%",
    bgcolor: "background.paper",
    borderRadius: "5px",
    overflow: "hidden",
  };

  useEffect(() => {
    if (siteId.get()) {
      dispatch(SITE_SERVICES.getV4GraphicsSiteService(siteId.get()));
    }
  }, [siteId.get()]);

    useEffect(() => {
    if (getV4GraphicsSiteData !== v4GraphicsSite) {
      setV4GraphicsSite(getV4GraphicsSiteData);
    }
  }, [getV4GraphicsSiteData]);

  useEffect(() => {
    if (
      updatedCarData.get() &&
      Object.keys(updatedCarData.get()).length !== 0
    ) {
      let localCarData = JSON.parse(updatedCarData.get());
      setCarData([...localCarData]);
    } else {
      setCarData([]);
    }
  }, [updatedCarData.get()]);

  useEffect(() => {
    setPendingPublishDate(getDateUTC(ScheduleSiteDataPublishAction));
  }, [ScheduleSiteDataPublishAction]);

  useEffect(() => {
    if (uploadKmlDataStatus === API_STATUSES.SUCCESS) {
      setSuccessKmlModal(true);
    }
  }, [uploadKmlDataStatus]);

  useEffect(() => {
    if (
      verifySiteSetupDataState &&
      siteSettingsData &&
      Object.keys(verifySiteSetupDataState).length !== 0 &&
      Object.keys(siteSettingsData).length !== 0
    ) {
      checkSiteSetup(verifySiteSetupDataState);
    }
  }, [verifySiteSetupDataState, siteSettingsData]);

  useEffect(() => {
    if (siteSetupData && Object.keys(siteSetupData).length !== 0) {
      setSiteDataExists(siteSetupData?.bSiteData);
      setHoleDataExists(siteSetupData?.HoleDatas?.length > 0);
      setVduViewDataExists(siteSetupData?.bVduView);
      setTeeMarkerSettingsExist(siteSetupData?.TeeMarkerSettings?.length > 0);
      setTeeMarkersExist(siteSetupData?.TeeMarkers?.length > 0);
      setPoiDataExists(siteSetupData?.PointsOfInterest?.length > 0);
      setMapImageLastUpdate(getDateUTC(siteSetupData?.MapImageLastUpdate));
      setGreenViewDataExists(siteSetupData?.bGreenViewData);
    }
  }, [siteSetupData]);

  useEffect(() => {
    if (siteSettingsData && Object.keys(siteSettingsData).length !== 0) {
      setFeaturesResortEdition(siteSettingsData?.Features.indexOf(featureKey.resortEdition) >= 0);
      setMapSendDate(getDateUTC(siteSettingsData?.MapsVersionDate));
      setSiteDataSendDate(getDateUTC(siteSettingsData?.SiteDataVersionDate));
      setPoiSendDate(getDateUTC(siteSettingsData?.POIsVersionDate));
      setTeeMarkerSendDate(getDateUTC(siteSettingsData?.TeeMarkersVersionDate));
      setGreenViewSendDate(getDateUTC(siteSettingsData?.GreenViewsVersionDate));
      setV3GraphicsSite(siteSettingsData?.V3GraphicsSiteId != null ? siteSettingsData?.V3GraphicsSiteId : 0);
    }
  }, [siteSettingsData]);

  useEffect(() => {
    if (!errorMsg && filesSelected) {
      setReadyToUpload(true);
    } else {
      setReadyToUpload(false);
    }
  }, [errorMsg, filesSelected]);

  useEffect(() => {
    if (uploadKmlDataStatus === API_STATUSES.ERROR) {
      setErrorModalStatus(true);
    } else {
      setErrorModalStatus(false);
    }
  }, [uploadKmlDataStatus]);

  useEffect(() => {
    if (carData && carData !== 0) {
      setIsEntireFleetG2(checkIsFleetG2());
      setIsEntireFleetLT(checkIsFleetLT());
      setIsEntireFleetFT(checkIsFleetFT());
      setIsEntireFleetWT(checkIsFleetWT());
    }
  }, [carData]);

  function enableSiteDataPublish() {
    return (
      !pendingPublishDate &&
      (enableSendSiteDataToCars() ||
        sendPOIEnable() ||
        sendTeeMarkersEnable() ||
        sendMapsEnable())
    );
  }

  function sendPOIEnable() {
    return (
      poiDataExists &&
      !poiSendDate &&
      !isHoleDataModified.get() &&
      !isTSModified.get()
    );
  }

  function sendTeeMarkersEnable() {
    return (
      teeMarkerSettingsExist &&
      teeMarkersExist &&
      !teeMarkerSendDate &&
      !isHoleDataModified.get() &&
      !isTSModified.get()
    );
  }

  function checkIsFleetG2() {
    if (carData.length === 0) return false;
    for (var i = 0; i < carData.length; i++) {
      // JG 30-Apr-17: for now counting FTs the same as G2s since this is typically used to filter out stuff that requires interaction
      // TBD: add additional filtering as appropriate based on new isEntireFleetFT observable
      if (
        carData[i].DevType !== deviceType.G2 &&
        carData[i].DevType !== deviceType.FT &&
        carData[i].DevType !== deviceType.WT
      ) {
        return false;
      }
    }
    return true;
  }

  function checkIsFleetLT() {
    if (carData.length === 0) return false;
    for (var i = 0; i < carData.length; i++) {
      if (carData[i].DevType !== deviceType.LT) {
        return false;
      }
    }
    return true;
  }

  function checkIsFleetFT() {
    if (carData.length === 0) return false;
    for (var i = 0; i < carData.length; i++) {
      if (carData[i].DevType !== deviceType.FT) {
        return false;
      }
    }
    return true;
  }

  function checkIsFleetWT() {
    if (carData.length === 0) return false;
    for (var i = 0; i < carData.length; i++) {
      if (carData[i].DevType !== deviceType.WT) {
        return false;
      }
    }
    return true;
  }

  function sendSiteDataEnable() {
    return (
      siteDataExists &&
      !siteDataSendDate &&
      !isHoleDataModified.get() &&
      !isTSModified.get()
    );
  }

  function enableSendSiteDataToCars() {
    return (
      sendSiteDataEnable() &&
      (vduViewDataExists ||
        featuresResortEdition ||
        isEntireFleetG2 ||
        isEntireFleetLT)
    );
  }

  function sendMapsEnable() {
    return (
      mapImageLastUpdate &&
      !mapSendDate &&
      !isHoleDataModified.get() &&
      !isTSModified.get()
    );
  }

  function sendGreenViewEnable() {
    return (
      greenViewDataExists &&
      !greenViewSendDate &&
      !isHoleDataModified.get() &&
      !isTSModified.get()
    );
  }

  function enableSiteDataVerify() {
    if (isEntireFleetFT || isEntireFleetWT) return false;
    if (isEntireFleetG2 || isEntireFleetLT) return siteDataExists; // FOR NOW only check basic condition if G2 site
    return (
      siteDataExists &&
      holeDataExists &&
      vduViewDataExists &&
      teeMarkerSettingsExist &&
      siteSettingsData?.Courses.length > 0
    );
  }

  function handleOpenModal(modalCond) {
    if (modalCond === "ResetSiteData") {
      setModalText("Are you sure you want to reset the site data version?");
      setModalName(modalCond);
      setOpenCommonModal(true);
    } else if (modalCond === "ResetTeeMarkers") {
      setModalText("Are you sure you want to reset the tee markers version?");
      setModalName(modalCond);
      setOpenCommonModal(true);
    } else if (modalCond === "ResetMaps") {
      setModalText("Are you sure you want to reset the maps version?");
      setModalName(modalCond);
      setOpenCommonModal(true);
    } else if (modalCond === "ResetGreenView") {
      setModalText("Are you sure you want to reset the green view version?");
      setModalName(modalCond);
      setOpenCommonModal(true);
    } else if (modalCond === "ResetPOI") {
      setModalText("Are you sure you want to reset the POI version?");
      setModalName(modalCond);
      setOpenCommonModal(true);
    } else if (modalCond === "ClearAllSite") {
      setModalText("Are you sure you want to clear all site data?");
      setModalName(modalCond);
      setOpenCommonModal(true);
    } else if (modalCond === "EnableAllAZ") {
      setModalText(
        "This will enable all Action Zones to be enforced for member cars and trigger Action Zones to be downloaded for each car, are you sure you want to do this?"
      );
      setModalName(modalCond);
      setEnableAZModal(true);
    } else if (modalCond === "DisableAllAZ") {
      setModalText(
        "This will disable all Action Zones from being enforced for member cars and trigger Action Zones to be downloaded for each car, are you sure you want to do this?"
      );
      setModalName(modalCond);
      setEnableAZModal(true);
    } else {
      setOpenCommonModal(false);
      setModalName("");
    }
  }

  function handleSiteDataConfiguration() {
    let payload = {
      SiteId: parseInt(siteId.get()),
    };

    if (modalName === "ResetSiteData") {
      dispatch(COMMON_SERVICES.resetSiteDataVersionServices(payload)).then(
        () => {
          dispatch(COMMON_SERVICES.getAllSiteSetupServices(siteId.get()));
          dispatch(COMMON_SERVICES.getSiteSettingsServices(siteId.get()));
        }
      );
      setOpenCommonModal(false);
      setModalName("");
    } else if (modalName === "ResetTeeMarkers") {
      dispatch(COMMON_SERVICES.resetTeeMarkersVersionServices(payload)).then(
        () => {
          dispatch(COMMON_SERVICES.getAllSiteSetupServices(siteId.get()));
          dispatch(COMMON_SERVICES.getSiteSettingsServices(siteId.get()));
        }
      );
      setOpenCommonModal(false);
      setModalName("");
    } else if (modalName === "ResetMaps") {
      dispatch(COMMON_SERVICES.resetMapsVersionServices(payload)).then(() => {
        dispatch(COMMON_SERVICES.getAllSiteSetupServices(siteId.get()));
        dispatch(COMMON_SERVICES.getSiteSettingsServices(siteId.get()));
      });
      setOpenCommonModal(false);
      setModalName("");
    } else if (modalName === "ResetGreenView") {
      dispatch(COMMON_SERVICES.resetGreenViewVersionServices(payload)).then(() => {
        dispatch(COMMON_SERVICES.getAllSiteSetupServices(siteId.get()));
        dispatch(COMMON_SERVICES.getSiteSettingsServices(siteId.get()));
      });
      setOpenCommonModal(false);
      setModalName("");
    } else if (modalName === "ResetPOI") {
      dispatch(COMMON_SERVICES.resetPOIsVersionServices(payload)).then(() => {
        dispatch(COMMON_SERVICES.getAllSiteSetupServices(siteId.get()));
        dispatch(COMMON_SERVICES.getSiteSettingsServices(siteId.get()));
      });
      setOpenCommonModal(false);
      setModalName("");
    } else if (modalName === "ClearAllSite") {
      dispatch(COMMON_SERVICES.clearSiteDataServices(payload));
      setOpenCommonModal(false);
      setModalName("");
    } else if (modalName === "EnableAllAZ") {
      dispatch(COMMON_SERVICES.enableAllAZsForMemberCarsServices(siteId.get()));
      setEnableAZModal(false);
      setModalName("");
    } else if (modalName === "DisableAllAZ") {
      dispatch(
        COMMON_SERVICES.disableAllAZsForMemberCarsServices(siteId.get())
      );
      setEnableAZModal(false);
      setModalName("");
    } else {
      return;
    }
  }

  function reset() {
    var pngSelector = document.getElementById("kmlPngFileSelect");

    if (pngSelector) pngSelector.value = "";
    setPngReferenced(false);
    setFilesSelected(false);
    setKmlFileName("");
    setPngFileName("");
    setErrorMsg("");
  }

  function kmlFileSelected(evt) {
    reset();
    if (evt.target.files.length === 1) {
      let file = evt.target.files[0];
      //  kmlFileName(file.name);
      setKmlFileName(file.name);
      if (file.name.match(".kml$") == ".kml") {
        try {
          // Try to open the file and check if it references a png overlay.
          let reader = new FileReader();
          reader.readAsText(file);
          reader.onloadend = function () {
            setPngReferenced(false);
            let xmlData = reader.result;
            let xml = new XMLParser().parseFromString(xmlData);

            let go = xml.getElementsByTagName("GroundOverlay");

            if (go.length > 0) {
              let h = xml.getElementsByTagName("href");

              if (h.length === 1) {
                setPngReferenced(true);
              }
            } else {
              //  filesSelected(true);
              setFilesSelected(true);
            }
          };
        } catch (e) {
          setErrorMsg("Error checking KML file for PNG reference.");
        }
      } else {
        setErrorMsg("Please select a kml file");
      }
    }
  }

  function pngFileSelected(evt) {
    setPngFileName("");

    if (evt.target.files.length === 1) {
      if (evt.target.files[0].name.match(".png") == ".png") {
        setPngFileName(evt.target.files[0].name);
        setFilesSelected(true);
        setErrorMsg("");
      } else {
        setFilesSelected(false);
        setErrorMsg(
          "Please select a png file for the Course Overlay referenced by the kml file."
        );
      }
    }
  }

  function matchSite(filename) {
    let name = filename.slice(0, -4);
    return name === siteId.get().toString();
  }

  function namesNotInExpectedFormat() {
    if (kmlFileName.length === 0 && pngFileName.length === 0) return false;

    // Check to see if the file names match the siteId.
    if (!matchSite(kmlFileName)) return true;

    if (pngReferenced) {
      if (!matchSite(pngFileName)) return true;
    }
    return false;
  }

  function uploadKml() {
    let maximumUploadSizeInBytes = 30000000; // 20mb

    let formData = new FormData();
    let selector = document.getElementById("kmlFileSelect");

    formData.append("kmlFile", selector.files[0]);
    let fileSize = selector.files[0].size;

    let pngFile = document.getElementById("kmlPngFileSelect");

    if (pngFile.files.length > 0) {
      formData.append("pngFile", pngFile.files[0]);
      fileSize += pngFile.files[0].size;
    }

    // Check max file size before sending to server
    if (fileSize < maximumUploadSizeInBytes) {
      dispatch(COMMON_SERVICES.uploadKmlService(formData, siteId.get()));
    } else {
      setErrorModalText(
        "File too large, files larger than 20mb cannot be uploaded"
      );
      setErrorModal(true);
    }
  }

  function doUpload() {
    if (namesNotInExpectedFormat()) {
      setErrorModal(true);
      setErrorModalText(
        "The KML and/or png file name does not match the expected format (siteId.kml or siteId.png).  Pressing Yes will rename the file(s) to the expected format when saving on server.  Press No to cancel upload. ",
        "Filenames Do Not Match Site"
      );
    } else uploadKml();
  }

  function processMapVerboseError(error) {
    switch (error) {
      case "wrong format":
        return "Invalid file format - only .zip files are allowed";
      case "exception":
        return "Failed to import data";
      case "save failed":
        return "Failed to save imported data";
      case "json file missing":
        return "Could not find json file in zip";
      case "site mismatch":
        return "Current site does not match import site";
      case "sitedata missing":
        return "No SiteData record found for current site";
      case "holedata missing":
        return "No HoleData records found for current site and course number";
      case "image missing":
        return "No associated image file found for JSON hole data";
      case "course count mismatch":
        return "The number of courses found in JSON data does not match the number of courses for this site";
      case "hole count mismatch":
        return "The number of holes found in JSON data does not match the number of holes for this site/course";
      case "set centerpoint failed":
        return "Failed to set site centerpoint";
      case "set radius and upper left failed":
        return "Failed to set radius and upper left coordinates";
      default:
        return "Failed to import data.  Detail received: " + error;
    }
  }

  function processGreenViewVerboseError(error) {
    switch (error) {
      case 'sitedata missing': return 'No SiteData record found for current site';
      case 'coordinate failure': return 'Invalid green view coordinate';
      case 'course name not found': return 'Could not find .zip course name in the database ';
      case 'hole data missing': return 'Could not find database HoleData for hole in .zip';
      case 'image missing': return 'No associated image file found for JSON hole data';
      case 'invalid course count': return 'Course count mismatch between .zip and database';
      case 'invalid site id': return 'Site ID in .zip does not match the database';
      case 'save failed': return 'Failed to save imported data';
      case 'json file missing': return 'Could not find json file in zip';
      case 'wrong format': return 'Invalid file format - only .zip files are allowed';
      case 'exception': return 'Failed to import data';
      default: return `Failed to import data.  Detail received: ${error}`;
    }
  }

  function checkHoleAreas(tHoleAreas, tHole, tCourse) {
    let tText = "";
    let tHoleAreasHole = _.filter(tHoleAreas, {
      Course: tCourse.Number,
      Hole: tHole,
    });
    if (tHoleAreasHole.length) {
      let hasTeeAreas = _.some(tHoleAreasHole, { Type: holeAreaType.Tee });
      let hasFairwayAreas = _.some(tHoleAreasHole, {
        Type: holeAreaType.Fairway,
      });
      let hasGreenAreas = _.some(tHoleAreasHole, {
        Type: holeAreaType.Green,
      });
      let hasExtentsAreas = _.some(tHoleAreasHole, {
        Type: holeAreaType.Extents,
      });
      if (
        !hasTeeAreas ||
        !hasFairwayAreas ||
        !hasGreenAreas ||
        !hasExtentsAreas
      ) {
        if (siteSettingsData?.Courses.length > 1) {
          tText += tCourse.Name + " ";
        }
        tText += "Hole " + tHole + " is missing Hole Areas:";
        if (!hasTeeAreas) {
          tText += " Tee ";
        }
        if (!hasFairwayAreas) {
          tText += " Fairway ";
        }
        if (!hasGreenAreas) {
          tText += " Green ";
        }
        if (!hasExtentsAreas) {
          tText += " Extents  ";
        }
        missingData.push(tText);
      }
    } else {
      if (siteSettingsData?.Courses.length > 1) {
        tText += tCourse.Name + " ";
      }
      tText +=
        "Hole " + tHole + " is missing Hole Areas: Tee Fairway Green Extents ";
      missingData.push(tText);
    }
  }

  function checkTeeMarkers(tTeeMarkers, tTeeMarkerSettings, tHole, tCourse) {
    let anyMissing = [];
    let tSettings = verifySiteSetupDataState?.UsingSharedTeeSettings
      ? tTeeMarkerSettings
      : _.filter(tTeeMarkerSettings, { CourseNumber: tCourse.Number });
    if (tSettings) {
      tSettings.forEach(function (ts) {
        if (
          !_.some(tTeeMarkers, {
            Course: tCourse.Number,
            Hole: tHole,
            TeeMarkerSettingId: ts.Id,
          })
        ) {
          anyMissing.push({
            Course: tCourse.Name,
            Hole: tHole,
            Name: ts.Name,
            Color: ts.ColorRGB,
          });
        }
      });
    }

    if (anyMissing.length) {
      anyMissing.forEach(function (m) {
        let tText = "";
        if (siteSettingsData?.Courses.length > 1) {
          tText += m.Course + " ";
        }
        tText +=
          "Hole " +
          m.Hole +
          " is missing tee marker. Setting Name: " +
          m.Name +
          ", Color: " +
          convIntToRGB(m.Color).toUpperCase();
        missingData.push(tText);
      });
    }
  }

  function checkCOGs(tHoleDatas, tHole, tCourse) {
    let cogNotSet = _.some(tHoleDatas, function (hd) {
      return (
        hd.Course === tCourse.Number &&
        hd.Hole === tHole &&
        hd.CogLat === 0 &&
        hd.CogLon === 0
      );
    });
    if (cogNotSet) {
      let tText = "";
      if (siteSettingsData?.Courses.length > 1) {
        tText += tCourse.Name + " ";
      }
      tText += "Hole " + tHole + " Center of Green is not set.";
      missingData.push(tText);
    }
  }

  const MaxPayLoadBytes = 1400; // max playload size currently allowed for G2
  function checkG2AreaPayloadSizes(sData) {
    var course = {};

    for (var c = 0; c < siteSettingsData?.Courses.length; c++) {
      var teeBytes = 0;
      var fairwayBytes = 0;
      var greenBytes = 10; // 10 byte overhead in AreaDataPayload

      course = siteSettingsData?.Courses[c];
      for (var hole = 1; hole <= course.HoleCount; hole++) {
        var teeAreas = _.filter(sData.HoleAreas, {
          Course: course.Number,
          Hole: hole,
          Type: holeAreaType.Tee,
        }); // get tee areas for this hole
        var fwAreas = _.filter(sData.HoleAreas, {
          Course: course.Number,
          Hole: hole,
          Type: holeAreaType.Fairway,
        }); // get fairway areas for this hole
        var greenAreas = _.filter(sData.HoleAreas, {
          Course: course.Number,
          Hole: hole,
          Type: holeAreaType.Green,
        }); // get green areas for this hole

        teeBytes += teeAreas.length * 2 + 2;
        fairwayBytes += fwAreas.length * 2 + 2;
        greenBytes += greenAreas.length * 2 + 2; // 2 bytes per hole, plus 2 bytes per area

        for (var i = 0; i < teeAreas.length; i++)
          teeBytes += teeAreas[i].Polygon.length * 8; // 8 bytes per vertex

        for (var i = 0; i < fwAreas.length; i++)
          fairwayBytes += fwAreas[i].Polygon.length * 8; // 8 bytes per vertex

        for (var i = 0; i < greenAreas.length; i++)
          greenBytes += greenAreas[i].Polygon.length * 8; // 8 bytes per vertex
      }
    }

    if (
      teeBytes > MaxPayLoadBytes ||
      fairwayBytes > MaxPayLoadBytes ||
      greenBytes > MaxPayLoadBytes
    ) {
      if (teeBytes > MaxPayLoadBytes)
        missingData.push(
          "Too many TEE area points for G2 (payload = " +
          teeBytes +
          ", max = " +
          MaxPayLoadBytes +
          ")"
        );
      if (fairwayBytes > MaxPayLoadBytes)
        missingData.push(
          "Too many FAIRWAY area points for G2 (payload = " +
          fairwayBytes +
          ", max = " +
          MaxPayLoadBytes +
          ")"
        );
      if (greenBytes > MaxPayLoadBytes)
        missingData.push(
          "Too many GREEN area points for G2 (payload = " +
          greenBytes +
          ", max = " +
          MaxPayLoadBytes +
          ")"
        );
      missingData.push(
        "--- You need to reduce the number of points in area polygons"
      );
    }
  }

  const v3GraphicsSites = siteLocationsData?.filter(x => x.Id != siteId.get()).map(location => ({
    value: location.Id,
    label: `${location.Name} - ${location.Id}`,
  }));

  const saveV3GraphicsSite = (value) => {
    setV3GraphicsSite(parseInt(value));

    dispatch(SITE_SERVICES.saveV3GraphicsSiteService(siteId.get(), parseInt(value)));
  }

  function checkSiteSetup(sData) {
    let tCourse = {};
    let tHole = 0;
    let tHolesInCourse = 0;

    //Check Site Areas
    if (sData?.SiteAreas?.length === 0) {
      missingData.push("No staging areas set.");
    }

    //Check All Other Site Setup Data
    for (let i = 0; i < siteSettingsData?.Courses.length; i++) {
      tCourse = siteSettingsData?.Courses[i];
      tHolesInCourse = tCourse.HoleCount;

      for (let j = 0; j < tHolesInCourse; j++) {
        tHole = j + 1;
        checkHoleAreas(sData.HoleAreas, tHole, tCourse);
        checkTeeMarkers(
          sData.TeeMarkers,
          sData.TeeMarkerSettings,
          tHole,
          tCourse
        );
        checkCOGs(sData.HoleDatas, tHole, tCourse);
      }
    }

    if (
      _.some(carData, { DevType: deviceType.G2 }) ||
      _.some(carData, { DevType: deviceType.LT })
    ) {
      checkG2AreaPayloadSizes(sData);
    }
  }

  async function verifySiteData() {
    setVerifyLoding(true);

    await getSiteSetupApiCall(headersConfigData, siteId.get())
      .then((response) => response.json())
      .then((data) => {
        if (data) {
          checkSiteSetup(data);
          if (missingData.length > 0) {
            let missingDataPoints = (
              <div>
                {missingData.map((item) => {
                  return <div>{item}</div>;
                })}
              </div>
            );
            setVerifyTitle("Missing/Incorrect data");
            setVerifyText(missingDataPoints);

            missingData.length = 0;
          } else {
            setVerifyTitle("Verified");
            setVerifyText("All site data has been setup");
          }
        } else {
          setVerifyTitle("Missing");
          setVerifyText("'No site data has been setup', 'Missing'");
        }
      });
    SetVerifyPopupOpen(true);

    setVerifyLoding(false);
  }

  return (
    <>
      <Modal
        open={openCommonModal}
        onClose={() => setOpenCommonModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <PopUpContainer>
            <h2>{t("Confirm")}</h2>
            <p>{modalText}</p>
            <div className="action-btn">
              <button
                className="primary"
                onClick={handleSiteDataConfiguration}
                variant="contained"
              >
                {t("Yes")}
              </button>
              <button onClick={() => setOpenCommonModal(false)}>
                {t("No")}
              </button>
            </div>
          </PopUpContainer>
        </Box>
      </Modal>
      <Modal
        open={successKmlModal}
        onClose={() => setSuccessKmlModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <PopUpContainer>
            <h2>Success</h2>
            <p>Upload successful</p>
            <div className="action-btn">
              <button
                className="primary"
                onClick={() => {
                  setSuccessKmlModal(false);
                  setReadyToUpload(false);
                  dispatch(uploadKmlDataStatusAction(API_STATUSES.IDLE));
                }}
              >
                {t("Ok")}
              </button>
            </div>
          </PopUpContainer>
        </Box>
      </Modal>
      <Modal
        open={enableAZModal}
        onClose={() => setEnableAZModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <PopUpContainer>
            <h2>
              {modalName === "EnableAllAZ"
                ? "Confirm Enable"
                : "Confirm Disable"}
            </h2>
            <p>{modalText}</p>
            <div className="action-btn">
              <button
                className="primary"
                onClick={handleSiteDataConfiguration}
                variant="contained"
              >
                {t("Yes")}
              </button>
              <button onClick={() => setEnableAZModal(false)}>{t("No")}</button>
            </div>
          </PopUpContainer>
        </Box>
      </Modal>
      <Modal
        open={openKml}
        onClose={() => setOpenKml(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <PopUpContainer>
            <div className="header">Upload KML</div>

            {kmlLayerData !== "" ? (
              <h4>
                <strong>Warning!</strong> KML data is already available on the
                server. Uploading will overwrite files.
              </h4>
            ) : (
              <></>
            )}
            <h5 className="p-inline-15 mb-10">KML File</h5>
            <div className="p-inline-15 mb-10">
              <UploadBtnWrapper>
                <input
                  type="file"
                  id="kmlFileSelect"
                  accept="application/kml"
                  onChange={(e) => kmlFileSelected(e)}
                />
              </UploadBtnWrapper>
            </div>

            {pngReferenced ? (
              <>
                <h5 className="p-inline-15 mb-10">Course Overlay (.png)</h5>
                <div className="p-inline-15 mb-10">
                  <UploadBtnWrapper>
                    <input
                      type="file"
                      id="kmlPngFileSelect"
                      accept="application/png"
                      onChange={(e) => pngFileSelected(e)}
                    />
                  </UploadBtnWrapper>
                </div>
              </>
            ) : (
              <></>
            )}
            {errorMsg !== "" ? (
              <p
                className="mb-0"
                style={{
                  color: "red",
                }}
              >
                {errorMsg}
              </p>
            ) : (
              <></>
            )}
            <div className="action-btn mt-20">
              <Tooltip title={t("Upload")}>
                <span>
                  <Button
                    variant="outlined"
                    disabled={!readyToUpload}
                    onClick={doUpload}
                    className={!readyToUpload ? "" : "primary"}
                  >
                    {t("Upload")}
                  </Button>
                </span>
              </Tooltip>
              <Tooltip title="Close">
                <Button
                  variant="outlined"
                  onClick={() => {
                    setOpenKml(false);
                    setPngReferenced(false);
                    setReadyToUpload(false);
                  }}
                >
                  Close
                </Button>
              </Tooltip>
            </div>
          </PopUpContainer>
        </Box>
      </Modal>
      <Modal
        open={errorModal}
        onClose={() => {
          setErrorModal(false);
          setErrorModalText("");
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <PopUpContainer>
            <div className="header">Filenames Do Not Match Site</div>
            <h4>{errorModalText}</h4>
            <div className="action-btn">
              <button
                onClick={() => {
                  uploadKml();
                  setOpenKml(false);
                  setErrorModal(false);
                  setErrorModalText("");
                  setPngReferenced(false);
                  // dispatch(uploadKmlDataStatusAction(API_STATUSES.IDLE));
                }}
                className="primary"
              >
                Yes
              </button>
              <button
                onClick={() => {
                  setErrorModal(false);
                  setErrorModalText("");
                }}
              >
                No
              </button>
            </div>
          </PopUpContainer>
        </Box>
      </Modal>
      <Modal
        open={errorModalStatus}
        onClose={() => {
          setErrorModalStatus(false);
          dispatch(uploadKmlDataStatusAction(API_STATUSES.IDLE));
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <PopUpContainer>
            <h4 className="p-inline-15 mb-10">Internal Server Error</h4>
            <div className="action-btn">
              <button
                onClick={() => {
                  setErrorModalStatus(false);
                  dispatch(uploadKmlDataStatusAction(API_STATUSES.IDLE));
                }}
                className="primary"
              >
                {t("Ok")}
              </button>
            </div>
          </PopUpContainer>
        </Box>
      </Modal>
      <Modal
        open={processMapModal}
        onClose={() => {
          setProcessMapModal(false);
          dispatch(createHoleMapImageDataStateAction({}));
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <PopUpContainer>
            {createHoleMapImageDataStatus === API_STATUSES.REQUEST && (
              <div style={{ height: "205px" }}>
                <Loader height="200px" containerHeight="auto" />
              </div>
            )}
            {createHoleMapImageDataStatus === API_STATUSES.SUCCESS && (
              <>
                <h2>{t("Success")}</h2>
                <p>
                  Map Images Processed file '
                  {createHoleMapImageDataState?.filename}' successfully"
                </p>
                <div className="action-btn">
                  <button
                    onClick={() => {
                      setProcessMapModal(false);
                      dispatch(createHoleMapImageDataStateAction({}));
                    }}
                    className="primary"
                  >
                    {t("Ok")}
                  </button>
                </div>
              </>
            )}

            {createHoleMapImageDataStatus === API_STATUSES.ERROR && (
              <>
                <h2>{t("Error")}</h2>
                <p>{processMapVerboseError(createHoleMapImageDataState)}</p>
                <div className="action-btn">
                  <button
                    onClick={() => {
                      setProcessMapModal(false);
                      dispatch(createHoleMapImageDataStateAction({}));
                    }}
                  >
                    {t("Ok")}
                  </button>
                </div>
              </>
            )}
          </PopUpContainer>
        </Box>
      </Modal>
      <Modal
        open={processGreenViewModal}
        onClose={() => {
          setProcessGreenViewModal(false);
          dispatch(processGreenViewDataStateAction({}));
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <PopUpContainer>
            {processGreenViewDataStatus === API_STATUSES.REQUEST && (
              <div style={{ height: "205px" }}>
                <Loader height="200px" containerHeight="auto" />
              </div>
            )}
            {processGreenViewDataStatus === API_STATUSES.SUCCESS && (
              <>
                <h2>{t("Success")}</h2>
                <p>
                  Green View processed file '
                  {processGreenViewDataState?.filename}' successfully"
                </p>
                <div className="action-btn">
                  <button
                    onClick={() => {
                      setProcessGreenViewModal(false);
                      dispatch(processGreenViewDataStateAction({}));
                    }}
                    className="primary"
                  >
                    {t("Ok")}
                  </button>
                </div>
              </>
            )}

            {processGreenViewDataStatus === API_STATUSES.ERROR && (
              <>
                <h2>{t("Error")}</h2>
                <p>{processGreenViewVerboseError(processGreenViewDataState)}</p>
                <div className="action-btn">
                  <button
                    onClick={() => {
                      setProcessGreenViewModal(false);
                      dispatch(processGreenViewDataStateAction({}));
                    }}
                  >
                    {t("Ok")}
                  </button>
                </div>
              </>
            )}
          </PopUpContainer>
        </Box>
      </Modal>
      <Modal
        open={resetCenterModal}
        onClose={() => setResetCenterModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <PopUpContainer>
            {resetSiteExtentsAndCtrPtToZeroStatusAction ===
              API_STATUSES.REQUEST && (
                <div style={{ height: "205px" }}>
                  <Loader height="200px" containerHeight="auto" />
                </div>
              )}
            {resetSiteExtentsAndCtrPtToZeroStatusAction ===
              API_STATUSES.SUCCESS && (
                <>
                  <h2>Update saved</h2>
                  <p>Reset Site Extents And CtrPt saved successfully</p>
                  <div className="action-btn">
                    <button
                      onClick={() => {
                        setResetCenterModal(false);
                      }}
                      className="primary"
                    >
                      {t("Ok")}
                    </button>
                  </div>
                </>
              )}
          </PopUpContainer>
        </Box>
      </Modal>
      <Modal
        open={
          verifyLoding ||
          uploadKmlDataStatus === API_STATUSES.REQUEST ||
          siteSetupStatus === API_STATUSES.REQUEST
        }
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={missingDataPopup}>
          <PopUpContainer>
            <div style={{ height: "205px" }}>
              <Loader height="200px" containerHeight="auto" />
            </div>
          </PopUpContainer>
        </Box>
      </Modal>
      <Modal
        open={publishDataModal}
        onClose={() => {
          setPublishDataModal(false);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <PopUpContainer>
            {pendingPublishDate && pendingPublishDate !== null && (
              <>
                <h2>Scheduled site data publishing</h2>
                <p>Site data will be published at midnight site time.</p>
                <div className="action-btn">
                  <button
                    onClick={() => {
                      setPublishDataModal(false);
                    }}
                    className="primary"
                  >
                    {t("Ok")}
                  </button>
                </div>
              </>
            )}
            {ScheduleSiteDataPublishStatusAction === API_STATUSES.REQUEST && (
              <div style={{ height: "205px" }}>
                <Loader height="200px" containerHeight="auto" />
              </div>
            )}
            {ScheduleSiteDataPublishStatusAction === API_STATUSES.ERROR && (
              <div style={{ height: "205px" }}>
                <p>Failed to schedule overnight publishing</p>
              </div>
            )}
          </PopUpContainer>
        </Box>
      </Modal>

      <VerifyPopup
        open={verifyPopupOpen}
        SetVerifyPopupOpen={SetVerifyPopupOpen}
        title={verifyTitle}
        text={verifyText}
        setVerifyTitle={setVerifyTitle}
      />
      <AccordionStyled>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Heading>
              <h3>{t("Site_Data_Configuration")}</h3>
            </Heading>
          </AccordionSummary>
          <AccordionDetails>
            {pendingPublishDate && pendingPublishDate !== null && (
              <p>Pending publish of all data to cars: {pendingPublishDate}</p>
            )}
            <SiteDataWorkSection>
              <SiteDataRow className="first-row">
                <button onClick={() => handleOpenModal("EnableAllAZ")}>
                  {t("Enable_All_AZs_for_Member_Cars")}
                </button>
                <button onClick={() => handleOpenModal("DisableAllAZ")}>
                  {t("Disable_All_AZs_for_Member_Cars")}
                </button>
              </SiteDataRow>
              <SiteDataRow className="sec-row">
                <button onClick={() => setOpenKml(true)}>
                  {t("Upload_KML")}
                </button>

                <div></div>
                <button
                  onClick={() => {
                    setResetCenterModal(true);
                    dispatch(COMMON_SERVICES.resetSiteExtentsAndCtrPtToZeroServices(siteId.get()));
                  }}
                >
                  {t("Reset_CenterPt_&_Extents_to_Zero")}
                </button>
              </SiteDataRow>
              <SiteDataRow>
                <button
                  disabled={siteDataExists || holeDataExists}
                  onClick={() => {
                    let payload = {
                      SiteId: parseInt(siteId.get()),
                    };
                    dispatch(
                      COMMON_SERVICES.createSiteDataServices(payload)
                    ).then(() => {
                      dispatch(
                        COMMON_SERVICES.getAllSiteSetupServices(siteId.get())
                      );
                      dispatch(
                        COMMON_SERVICES.getSiteSettingsServices(siteId.get())
                      );
                    });
                  }}
                >
                  {t("Create_initial_site_data")}
                </button>
                <button
                  disabled={!enableSendSiteDataToCars()}
                  onClick={() => {
                    dispatch(
                      COMMON_SERVICES.sendSiteDataServices(siteId.get())
                    ).then(() => {
                      dispatch(
                        COMMON_SERVICES.getAllSiteSetupServices(siteId.get())
                      );
                      dispatch(
                        COMMON_SERVICES.getSiteSettingsServices(siteId.get())
                      );
                    });
                  }}
                >
                  {t("Send_SiteData_to_Cars")}
                </button>
                <button
                  disabled={!siteDataExists}
                  onClick={() => handleOpenModal("ResetSiteData")}
                >
                  {t("Reset_Site_Data_Version")}
                </button>
              </SiteDataRow>
              <SiteDataRow>
                <button
                  disabled={!siteDataExists || !holeDataExists}
                  onClick={() => {
                    setProcessMapModal(true);
                    dispatch(COMMON_SERVICES.createHoleMapImageDataService(siteId.get(), deviceType.VDU3));
                  }}
                >
                  {t("Process_v3_map_image_zip")}
                </button>
                <button
                  disabled={!sendMapsEnable()}
                  onClick={() => {
                    dispatch(
                      COMMON_SERVICES.sendMapDataServices(siteId.get())
                    ).then(() => {
                      dispatch(
                        COMMON_SERVICES.getAllSiteSetupServices(siteId.get())
                      );
                      dispatch(
                        COMMON_SERVICES.getSiteSettingsServices(siteId.get())
                      );
                    });
                  }}
                >
                  {t("Send_Maps_to_Cars")}
                </button>
                <button
                  disabled={!siteDataExists}
                  onClick={() => handleOpenModal("ResetMaps")}
                >
                  {t("Reset_Maps_Version")}
                </button>
              </SiteDataRow>
              <SiteDataRow>
                {(v3GraphicsSite == 0 && v4GraphicsSite != "") ?
                  (<div style={{ marginBottom: 15, fontSize: 12, fontWeight: 'bold' }}>V4 Graphics Site: {getV4GraphicsSiteData}</div>) :
                  <div></div>
                }
                {mapImageLastUpdate && mapImageLastUpdate !== null && (
                  <>
                    <p
                      style={{
                        fontSize: "12px",
                        fontWeight: "bold",
                        marginBottom: "10px",
                      }}
                    >
                      Last upload: {mapImageLastUpdate}
                    </p>
                  </>
                )}
              </SiteDataRow>
              <SiteDataRow>
                <button
                  disabled={!siteDataExists || !holeDataExists}
                  onClick={() => {
                    setProcessMapModal(true);
                    dispatch(COMMON_SERVICES.createHoleMapImageDataService(siteId.get(), deviceType.VDU4));
                  }}
                >
                  {t("Process_v4_map_image_zip")}
                </button>
                <div></div>
                <button
                  disabled={!teeMarkerSettingsExist || !sendTeeMarkersEnable()}
                  onClick={() => {
                    dispatch(
                      COMMON_SERVICES.sendTeeMarkerDataServices(siteId.get())
                    ).then(() => {
                      dispatch(
                        COMMON_SERVICES.getAllSiteSetupServices(siteId.get())
                      );
                      dispatch(
                        COMMON_SERVICES.getSiteSettingsServices(siteId.get())
                      );
                    });
                  }}
                >
                  {t("Send_TeeMarkers_to_Cars")}
                </button>
              </SiteDataRow>
              <SiteDataRow>
                {(v4GraphicsSite === "") ?
                <div style={{ marginBottom: 15 }}>
                  V3 Graphics Site:
                  <FormControl size="small">
                    <div style={{ width: 245 }}>
                      <Select
                        options={v3GraphicsSites}
                        value={v3GraphicsSites.find(
                          option => option.value === v3GraphicsSite
                        )}
                        placeholder="Choose a V3 Graphic Site"
                        onChange={(option) => saveV3GraphicsSite(option.value)}
                        isSearchable
                      />
                    </div>
                  </FormControl>
                </div> : 
                <div></div>
                }
              </SiteDataRow>
              <SiteDataRow>
                <button
                  disabled={!siteDataExists}
                  onClick={() => handleOpenModal("ResetTeeMarkers")}
                >
                  {t("Reset_Tee_Markers_Version")}
                </button>
                <button
                  disabled={!sendPOIEnable()}
                  onClick={() => {
                    dispatch(
                      COMMON_SERVICES.sendPOIDataServices(siteId.get())
                    ).then(() => {
                      dispatch(
                        COMMON_SERVICES.getAllSiteSetupServices(siteId.get())
                      );
                      dispatch(
                        COMMON_SERVICES.getSiteSettingsServices(siteId.get())
                      );
                    });
                  }}
                >
                  {t("Send_POIs_to_Cars")}
                </button>
                <button
                  disabled={!siteDataExists}
                  onClick={() => handleOpenModal("ResetPOI")}
                >
                  {t("Reset_POIs_Version")}
                </button>
              </SiteDataRow>
              <SiteDataRow>
                <button
                  disabled={!siteDataExists || !holeDataExists}
                  onClick={() => {
                    setProcessGreenViewModal(true);
                    dispatch(COMMON_SERVICES.processGreeViewZipFileService(siteId.get()));
                  }}
                >
                  {t("Process_green_view_zip")}
                </button>
                <button
                  disabled={!sendGreenViewEnable()}
                  onClick={() => {
                    dispatch(
                      COMMON_SERVICES.sendGreenViewDataServices(siteId.get())
                    ).then(() => {
                      dispatch(
                        COMMON_SERVICES.getAllSiteSetupServices(siteId.get())
                      );
                      dispatch(
                        COMMON_SERVICES.getSiteSettingsServices(siteId.get())
                      );
                    });
                  }}
                >
                  {t("Send_Green_View_Zip")}
                </button>
                <button
                  disabled={!siteDataExists}
                  onClick={() => handleOpenModal("ResetGreenView")}
                >
                  {t("Reset_Green_View_Version")}
                </button>
              </SiteDataRow>
              <SiteDataRow>
                <button
                  disabled={!enableSiteDataVerify()}
                  onClick={() => {
                    verifySiteData();
                  }}
                >
                  {t("Verify_Site_Setup_is_Complete")}
                </button>
              </SiteDataRow>
              <SiteDataRow>
                <div></div>
                <button
                  disabled={!enableSiteDataPublish()}
                  onClick={() => {
                    setPublishDataModal(true);
                    dispatch(COMMON_SERVICES.scheduleSiteDataPublishServices(siteId.get()));
                  }}
                >
                  {t("Publish_All_Data_Overnight_to_Cars")}
                </button>
                <button
                  disabled={!siteDataExists}
                  onClick={() => handleOpenModal("ClearAllSite")}
                >
                  {t("Clear_all_site_data")}
                </button>
              </SiteDataRow>
              <SiteDataRow>
                <button
                  onClick={() => {
                    dispatch(
                      COMMON_SERVICES.setAdminCodeService(siteId.get())
                    ).then(() => {
                      dispatch(COMMON_SERVICES.getSiteSettingsServices(siteId.get()));
                    });
                  }}
                >
                  {t("Generate_New_Admin_Code")}
                </button>
              </SiteDataRow>
              <SiteDataRow>
                {(
                  <>
                    <p
                      style={{
                        fontSize: "12px",
                        fontWeight: "bold",
                        marginBottom: "10px",
                      }}
                    >
                      Current Admin Code: {siteSettingsData?.AdminCode}
                    </p>
                  </>
                )}
              </SiteDataRow>
            </SiteDataWorkSection>
          </AccordionDetails>
        </Accordion>
      </AccordionStyled>
    </>
  );
};

export default SiteDataConfiguration;
